import React from 'react';
import { Strikethrough } from 'styled-icons/boxicons-regular/Strikethrough';

function StrikeIcon(props) {
  return (
    <Strikethrough {...props} className={'icon'} />
  );
}

export default StrikeIcon;
